import React, { useEffect, useState } from 'react';
import { CommonWrapper } from '../../CommonWrapper';
import RadioGroup from 'ds/components/input/RadioGroup';
import { useLocale } from 'locale';
import CheckboxGroup from 'ds/components/input/CheckboxGroup';
import { Button } from 'ds/components/button';
import { Nav } from '../../styled';
import { CheckboxWrapper } from './styled';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { isEqual } from 'lodash';

interface IInvestmentArea {
  isActive: boolean;
  isSaved: boolean;
  title: string;
  text?: string;
  btnText?: string;
  setArea?: () => void;
  data: string[] | null | false;
  onUpdate: (data: { [key: string]: any }) => void;
  selfClick?: () => void;
  fullActive?: boolean;
}

const places = [
  { value: 'מחוז-תל-אביב-ישראל', label: 'מחוז תל אביב' },
  { value: 'מחוז-חיפה-ישראל', label: 'מחוז חיפה' },
  { value: 'מחוז-המרכז-ישראל', label: 'מחוז המרכז' },
  { value: 'מחוז-ירושלים-ישראל', label: 'מחוז ירושלים' },
  { value: 'מחוז-הדרום-ישראל', label: 'מחוז הדרום' },
  { value: 'מחוז-הצפון-ישראל', label: 'מחוז הצפון' },
  { value: 'אזור-יהודה-ושומרון-ישראל', label: 'מחוז יהודה ושומרון' },
];

const MAX_ARR_LENGTH = 7;

export const InvestmentArea: React.FC<IInvestmentArea> = ({ isActive, isSaved, title, text, btnText, data, onUpdate, setArea, selfClick, fullActive }) => {
  const { t } = useLocale();
  const [ value, setValue ] = useState(null);
  const [ localList, setLocalList ] = useState(null);
  const screen = useScreenBreakpoint();
  const isMobile = screen === 1;

  useEffect(() => {
    if (!isEqual(data, localList)) {
      if (data && data.length && data.length !== MAX_ARR_LENGTH) {
        setValue('1');
        setLocalList(data);
      }
      else {
        setValue('');
        setLocalList(data);
      }
    }
  }, []);

  const handleRadioChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
    setLocalList(e.currentTarget.value ? [] : places.map(el => el.value));
  };

  const handleCheckboxChange = (e: string[]) => {
    setLocalList(e);
  };

  const handleSubmit = () => {
    setArea();
    onUpdate({ placeDocIds: localList && localList.length && localList.length !== MAX_ARR_LENGTH ? localList : places.map(el => el.value) });
  };

  const isDisabled = fullActive
    ? (value === null || (value === (!data || !data.length || data.length === MAX_ARR_LENGTH ? '' : '1') && isEqual(localList, data)))
    : (value === null);

  return (
    <CommonWrapper {...{ isActive, isSaved, title, text, selfClick }}>
      <>
        <RadioGroup
          value={value}
          onChange={handleRadioChange}
          name="investmentArea"
          options={[
            { label: t('investors.investment.no'), value: '' },
            { label: t('investors.investment.yes'), value: '1' },
          ]}
        />
        {value ? (
          <CheckboxWrapper>
            <CheckboxGroup
              value={localList}
              options={places}
              name="places"
              onChange={handleCheckboxChange}
            />
          </CheckboxWrapper>
        ) : null}
        {isActive ? (
          <Nav>
            <Button
              size="extraLarge"
              fullWidth={isMobile}
              disabled={isDisabled}
              onClick={handleSubmit}
            >
              {btnText || t('investors.wizard.submitButton')}
            </Button>
          </Nav>
        ) : null}
      </>
    </CommonWrapper>
  );
};
